import React from 'react'
import { Link } from 'react-router-dom'
import NavHome from '../../components/navHome/NavHome'
import Waves from '../../components/waves/Waves'
import "./notFound.scss"
import {useTranslation} from  'react-i18next'

export default function NotFound() {
  const {t} = useTranslation(["common"]);

  return (
    <div className='notFound'> 
        <NavHome/>
        <div className="container">
            <img className="nfIcon"src="https://cdn-icons-png.flaticon.com/512/1178/1178479.png" alt="" />
            <div className='text'>
                <h1>{t("NotFound")}</h1>
                <Link to="/"className='volver'><h2 >{t("NotFoundBack")}</h2></Link>
            </div>
        </div>
  
    <Waves/>
    </div>
  )
}
